const defaultTheme = {
  thRoot: 'overflow-hidden sm:flex -mx-2',
  thLeft: 'flex-1 p-2',
  thRight: 'flex-1 p-2',
  thTitleTheme: 'title-brand-10',
  thSmall: 'lowercase text-base rtl:ml-1',
  thSubtitle: 'mt-4',
  thSubtitleTheme: 'title-sans-11',
};

export const themes = {
  default: defaultTheme,
  fancy: {
    ...defaultTheme,
    thTitleTheme: 'title-serif-5',
  },
};
